import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  PRODUTOS: 'Carregando Produtos',
  POSICOES: 'Carregando posições do estoque',
  POSICOES_SAIDA: 'Carregando posições do estoque que contem o produto',
  EXPEDIR: 'Expedindo items selecionados',
  MOVING: 'Concluindo operação',
}

const INITIAL_STATE = {
  selectedPosicao: null,
  selectedEstoque: null,
  selectedTypeVisualizer: { label: 'Geral', value: 'Geral' },
  empresas: getEmpresas().map(emp => ({ label: emp.name, value: emp.name })),
  selectedEmpresa: null,
  posicoes: [],
  estoques: [],
  produtos: [],
  originalProdutos: [],
  filteredProdutos: [],
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useVerEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutosOnPosicao(selectedTp, posicaoId) {
        EstoqueHttp.getProdutosOnPosicaoEstoqueVisualizer(selectedTp, posicaoId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtos: res,
              originalProdutos: res,
              posicoes: Array.from(new Set(res.map(p => p.endereco))).map(end => ({
                label: end,
                value: end,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onChangeEmpresa(dt, event) {
        dt.current.filter(event.value, 'company_name', 'equals')
        setState(prevState => ({ ...prevState, selectedEmpresa: event.value }))
      },

      //Events
      async onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          EstoqueHttp.getEstoques(selectedTp)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          switch (name) {
            case 'selectedEstoque':
              prevState.loadingMessage = LOAD_MESSAGE.PRODUTOS
              break
            case 'selectedTypeVisualizer':
              prevState.produtos = prevState.originalProdutos
              prevState.selectedPosicao = null
              break
            case 'selectedPosicao':
              if (value)
                prevState.produtos = prevState.originalProdutos.filter(
                  p => p.endereco === value.value,
                )
              else prevState.produtos = prevState.originalProdutos
              break
            default:
              break
          }

          return { ...prevState }
        })
      },

      generateExcel(produtos, selectedEmpresa, selectedEstoque) {
        if (!produtos.length || !selectedEstoque)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma posição antes de tentar exportar os produtos',
          }))
        else {
          const colunasPosicoes = [
            [
              'Posição',
              'Código',
              'Produto',
              'Quantidade',
              'Validade',
              'Lote',
              'Empresa',
              'Etiqueta',
              'Identificador',
              'Falta',
              'Sobra',
              'Palletizado',
              'Rastreavel',
            ],
          ]

          let productsToInsert = produtos

          if (selectedEmpresa) {
            productsToInsert = produtos.filter(
              p => p.company_name.toLowerCase() === selectedEmpresa.toLowerCase(),
            )
          }

          colunasPosicoes.push(
            ...productsToInsert.map(p => [
              p.endereco,
              p.product_code,
              p.name,
              Number(p.quantidade),
              p.validade,
              p.lote,
              p.company_name,
              p.pallet_area_id,
              p.identifiers,
              p.missing_product_id ? 'Sim' : 'Não',
              p.letfover_product_id ? 'Sim' : 'Não',
              p.pallet_area_id ? 'Sim' : 'Não',
              p.pallet_area_id || p.picking_id || p.delivery_id ? 'Sim' : 'Não',
            ]),
          )

          gerarArquivoExcel('Produtos', colunasPosicoes, `Produtos - ${selectedEstoque.name}.xlsx`)
        }
      },

      async updatePosicaoItem(selectedTp, itemId, data) {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.PRODUTOS }))
        try {
          await EstoqueHttp.updatePosicaoEstoqueItem(selectedTp, itemId, data)
          // Recarrega os produtos após atualizar
          localDispatch.getProdutosOnPosicao(selectedTp, state.selectedEstoque.id)
        } catch (err) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
    }
  }, [state.selectedEstoque])

  return { state, localDispatch }
}
